import { IState } from '../../../store';
import { getOfferType, FOfferType } from '../../../utils/offer_type';
import { getIsFromBuilder } from '../../newObject';

/** Новостройка от застройщика */
export function isNewbuildingFromBuilderSelector(state: IState) {
  const isFromBuilder = getIsFromBuilder(state);
  const { offer } = state.offerData;
  const offerType = getOfferType(offer);

  return isFromBuilder && offerType === FOfferType.FlatNew;
}
